module.exports = __webpack_public_path__ + "static/img/banner1.f2abd80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner1.jpg
// module id = bvHn
// module chunks = 9